import React, { Component } from "react";

import Modal from "../../../../component/modal/ModalTemplate";
import CountdownTimer from "../../../../component/CountdownTimer";
import TextInput from "../../../../component/input/TextInput";
import button from "bootstrap/js/src/button";

class VerifyModal extends Component {
    constructor(props) {
        super(props);

        this.alertOpenClick = this.alertOpenClick.bind(this);
        this.state = {
            retry: false,
        }
    }

    alertOpenClick() {
        const { openAlert, closeAlert } = this.props;
        openAlert(
            "담당자 메일 수정을 원하는 경우에는," +
            "\ntf@biztalk.co.kr 로 아래 양식과 함께 사업자 등록증과 대표자 신분증을 함께 전달 부탁드립니다." +
            "\n대표자가 아닌 경우 최근 3개월 이내 발급 받은 재직증명서 첨부하여 전달 부탁드립니다." +
            "\n\n\n[양식]\n업체명 :"+
            '\n업체명 ID :'+
            "\n변경 희망 담당자명 :"+
            "\n변경 희망 담당자 e-mail : ",
            [{onClick: function() {closeAlert()}, label: '확인', className: "btn btn-primary btn-md"}]
        )
    }

    render() {
        const { open, handleClose, session, setValue } = this.props;
        const { validateSessionAction, findIdAction } = this.props;
        const { alertOpenClick } = this;
        const { retry } = this.state;

        return(
            <Modal
                open={open}
                handleClose={handleClose}
                modalTitle={"아이디 / 비밀번호 찾기"}
                className={"react-modal"}
            >
                <div className={"modal-body"}>
                    <p>회원가입 시 설정한 <strong className="text-warning">[담당자 이메일 정보]</strong>로 인증 메일을 발송해 드렸습니다.</p>
                    <p>인증 번호 확인 후 비밀 번호 변경이 가능 합니다.</p>
                    <div className="d-flex align-items-center col-10 pb-3">
                        <label className={"pe-3 text-nowrap"}>인증번호</label>
                        <TextInput
                            className="form-control"
                            type="text"
                            id="session"
                            value={session}
                            onChange={setValue}
                            onKeyDown={validateSessionAction}
                        />
                    </div>
                    <CountdownTimer seconds={180} onComplete={() => {alert('인증 시간이 끝났습니다!');
                                                                            this.setState({ retry: true }); }} />

                    <div className={"modal-footer justify-content-center"}>
                        <button className={"btn btn-primary btn-md me-2  mb-2 mb-sm-0"} onClick={validateSessionAction}>인증번호 확인</button>
                        <button className={"btn btn-primary btn-md ms-sm-2"} onClick={alertOpenClick}>담당자 메일 수정</button>
                        {retry && <button className={"btn btn-warning btn-md mt-3"} onClick={() => {
                            handleClose();
                            findIdAction();}  }>인증 번호 재전송</button>}
                    </div>
                </div>
            </Modal>
        )
    }
}// end class

export default VerifyModal;
